var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"squeezecontent"}},[_c('UIHeader',{attrs:{"critical":true}}),_vm._v(" "),_c('CartBannerTop'),_vm._v(" "),_c('div',{staticClass:"fixedwidth !pt-0"},[_c('div',{staticClass:"!pt-0"},[_c('UIBreadcrumb',{attrs:{"classes":''}})],1)]),_vm._v(" "),_c('Nuxt',{staticClass:"z-10"}),_vm._v(" "),_c('UIFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }